var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTree(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M413.848 447.996H256.021V480C256.021 497.673 241.694 512 224.021 512H224.021C206.349 512 192.023 497.674 192.023 480.002V447.996H33.123C4.624 447.996 -10.563 413.494 8.436 391.586L77.414 311.988H62.216C36.809 311.988 23.065 282.223 39.542 262.883L99.949 191.98H89.215C67.934 191.98 56.341 169.479 69.934 154.666L204.704 8.163C215.1 -3.137 232.934 -3.141 243.334 8.157L378.204 154.666C391.828 169.479 380.204 191.98 358.923 191.98H348.158L408.513 262.894C424.975 282.237 411.229 311.988 385.829 311.988H370.63L439.608 391.586C458.736 413.66 443.057 447.996 413.848 447.996Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTree);
export default __webpack_public_path__ + "static/media/tree.c786e4f15ae073e9bfc98d320fee1889.svg";
export { ForwardRef as ReactComponent };